import styled from 'styled-components';

export const CommunityWrapper = styled.div`
  width:100%;
  margin:0 auto;
`

export const FoundationBox = styled.div`
  width:100%;
  min-height: 60px;
  background: #fff;
  border-bottom: #D6D6D6 0.5px solid;
  color: #203152;
  font-size: 18px;
  display: flex;
  align-items:center;
  justify-content: space-between;
  padding: 0 4%;
  >input {
    width: 100%;
    border: 0;
  }
`
export const FoundationBoxTag = styled.div`
  width:100%;
  min-height: 60px;
  background: #fff;
  border-bottom: #D6D6D6 0.5px solid;
  display: flex;
  align-items:center;
  .ant-select-selector{
    border: 0 !important;
    box-shadow:0 0 0 rgba(0, 0, 0, 0)!important;
  }
  .ql-toolbar{
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: #eeeeee 0.5px solid !important;
  }
  .ql-container{
    border: 0 !important;
  }
`
export const PictureBox = styled.div`
  width:100%;
  min-height: 60px;
  background: #fff;
  border-bottom: #D6D6D6 0.5px solid;
  color: #203152;
  font-size: 18px;
  padding: 15px 4%;
  .picture_radio {
    display: flex;
    justify-content:space-between;
    margin-bottom: 20px;
  }
  .picture_title {
    margin-bottom: 12px;
  }
  .picture_one_img{
    width: 100%;
    img{
        width: 100%;
    }
  }
  .picture_three_img{
    width: 100%;
    img{
        width: 100px;
    }
  }
`

